module.exports = __webpack_public_path__ + "static/aligned-d3f3d30ef5ca3b378d1367bcf04bf53f.png";